import React, { useEffect, useMemo, useRef } from 'react'
import { getObjectUrl } from 'utils/mediaUtils'

const VideoWrapper = ({ id, s3Object, isLocal, cache, muted, className, autoplay }) => {
  const videoRef = useRef(null)
  const src = useMemo(() => {
    if (isLocal && cache) {
      try {
        return URL.createObjectURL(cache)
      } catch (e) {
        return null
      }
    }
    return getObjectUrl(s3Object)
  }, [isLocal, cache, s3Object])

  useEffect(() => {
    const video = videoRef.current
    if (!video || !src) return
    video.load()
    if (autoplay) {
      const p = video.play()
      if (p && typeof p.then === 'function') p.catch(() => {})
    }
  }, [src, autoplay])

  useEffect(() => {
    return () => {
      if (isLocal && src) URL.revokeObjectURL(src)
    }
  }, [isLocal, src])

  return (
    <video
      id={id}
      ref={videoRef}
      controls
      preload=""
      muted={muted}
      className={className}
      autoPlay={autoplay}
      src={src || ''}
      playsInline
    />
  )
}

export default VideoWrapper
